import type { OnInit } from '@angular/core'
import { Component, Input, inject, input } from '@angular/core'

import { TranslatePipe, TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'dhp-author-guidelines',
  templateUrl: './author-guidelines.component.html',
  styleUrls: ['./author-guidelines.component.scss'],
  imports: [TranslatePipe],
})
export class AuthorGuidelinesComponent implements OnInit {
  private translateService = inject(TranslateService)

  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() instructionsUrls?: Record<string, string>
  readonly hideTitle = input(false)

  ngOnInit(): void {
    // Handle backward compatibility - convert individual URLs to map if needed
    const instructionsNlUrl = this.instructionsNlUrl()
    const instructionsEnUrl = this.instructionsEnUrl()
    if (!this.instructionsUrls && (instructionsNlUrl || instructionsEnUrl)) {
      this.instructionsUrls = {}
      if (instructionsNlUrl) {
        this.instructionsUrls['nl'] = instructionsNlUrl
      }
      if (instructionsEnUrl) {
        this.instructionsUrls['en'] = instructionsEnUrl
      }
    }
  }

  /** Returns the appropriate PDF URL based on current language and availability */
  getPdfUrl(): string | null {
    if (!this.instructionsUrls) {
      return null
    }

    const currentLang = this.translateService.getCurrentLang()

    // Try to get URL for current language
    if (currentLang && this.instructionsUrls[currentLang]) {
      return this.instructionsUrls[currentLang]
    }

    // Fallback to browser language
    const browserLang = this.translateService.getBrowserLang() ?? ''
    if (browserLang && this.instructionsUrls[browserLang]) {
      return this.instructionsUrls[browserLang]
    }

    // Fallback to first available URL
    const availableLanguages = Object.keys(this.instructionsUrls)
    if (availableLanguages.length > 0) {
      return this.instructionsUrls[availableLanguages[0]]
    }

    // No URL available
    return null
  }

  // Legacy inputs for backward compatibility
  readonly instructionsNlUrl = input<string>()
  readonly instructionsEnUrl = input<string>()
}
